import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** The one class combinator (clsx + tailwind-merge), as digitaladmin has it. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
